import ActionTypes from "../constants/action-types";

export const setPersonalNoteIsBusy = (payload) => ({
    type: ActionTypes.SET_PERSONAL_NOTES_IS_BUSY,
    payload
});

export const setPersonalNoteIsOpen = (payload) => ({
    type: ActionTypes.SET_PERSONAL_NOTES_IS_OPEN,
    payload
});

export const setActivePersonalNote = (payload) => ({
    type: ActionTypes.SET_ACTIVE_PERSONAL_NOTE,
    payload
});


export const resetPersonalNote = () => (dispatch) => {
    dispatch({
        type: ActionTypes.RESET_PERSONAL_NOTE,
        payload: {
            isBusy: false,
            isOpen: false,
            activeNote: [],
        },
    });
};
